import { IResponse } from "models";

export enum ActionType {
  GET_FIRST_SECTION_DATA = "action/GET_FIRST_SECTION_DATA",
  GET_FIRST_SECTION_DATA_SUCCESS = "action/GET_FIRST_SECTION_DATA_SUCCESS",
  GET_FIRST_SECTION_DATA_ERROR = "action/GET_FIRST_SECTION_DATA_ERROR",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface IFirstSectionPayload extends IResponse {
  month?: number;
  year?: number;
  designation_id?: number;
}

export interface IFirstSectionResponse extends IResponse {
  result: any;
}
